var flagsmith = {exports: {}};

export { flagsmith as __module };
//# sourceMappingURL=index2.js.map
